import { formatDuration, type Duration } from 'date-fns'

import type { Time } from '@/types/time'
import { getDateFnsLocale } from '@/utils/format-date'

export const getDurationFromTime = (
  time: Time
): { hours: number; minutes: number } => {
  const [hours, minutes] = time.split(':').map(Number)

  return {
    hours,
    minutes
  }
}

const localizedFormatDuration = (duration: Duration): string =>
  formatDuration(duration, { locale: getDateFnsLocale() })

export const formatTimeDuration = (time: Time): string =>
  localizedFormatDuration(getDurationFromTime(time))
